import FontsContentSection from "containers/admin/clients/client/theme-page/preview/sub-tabs/fonts/fonts-section-content";

import { PreviewSidebarItemType } from "containers/admin/clients/client/theme-page/preview/preview-sidebar/preview-sidebar.types";

export const FONTS_TAB_SIDEBAR: PreviewSidebarItemType[] = [
  { titleText: "FONT FAMILY", children: <FontsContentSection /> },
];

export const BEE_CONFIG_WEIGHT_LABELS: Record<number, string> = {
  100: "Thin",
  200: "Extra-light",
  300: "Light",
  400: "Regular",
  500: "Medium",
  600: "Semi-bold",
  700: "Bold",
  800: "Extra-bold",
  900: "Black",
};

export const APP_WEIGHT_LABELS: Record<string, string> = {
  "900": "900 (black)",
  "800": "800 (extra bold)",
  "700": "700 (bold)",
  "600": "600 (semibold)",
  "500": "500 (medium)",
  "400": "400 (normal)",
  "300": "300 (light)",
  "200": "200 (extra light)",
  "100": "100 (thin)",
};
